import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AdminDashboardService } from '../../services/admin-dashboard.service';
import { ConfirmationService } from '../../shared/services/confirmation.service';
import { AddCelebrityComponent } from './add-celebrity/add-celebrity.component';
import { NotificationService } from '../../services/notification.service';
import { CommonService } from '../../shared/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditCelebrityComponent } from './edit-celebrity/edit-celebrity.component';
import { LoaderService } from '../../services/loader.service';
import { getCurrentUser } from '../../shared/utils/auth.utils';

interface Celebrity {
  id: number;
  name: string;
  email: string;
  category: any;
  domain: any;
  videos_count: number;
  status: 'active' | 'inactive' | 'pending';
  totalVideos: number;
  rating: number;
  revenue: number;
  profile_picture: string;
  prenom: string;
  official: any;
}


@Component({
  selector: 'app-admin-celebrities',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    RouterModule
  ],
  templateUrl: './admin-celebrities.component.html',
  styleUrls: ['./admin-celebrities.component.scss']
})
export class AdminCelebritiesComponent implements OnInit {
  celebrities: Celebrity[] = [];
  filteredCelebrities: Celebrity[] = [];
  searchTerm: string = '';
  statusFilter: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  totalPages: number = 0;
  fileData?: any;
  loading: boolean = true;
  error: string = '';
  allCelebrities: Celebrity[] = []; // Stocke toutes les célébrités non filtrées
  private userPermissions: string[] = [];

  constructor(
    private adminService: AdminDashboardService,
    private confirmationService: ConfirmationService,
    private notificationService: NotificationService,
    private fb: FormBuilder, 
    private router: Router,
    public commonService: CommonService,
    public modal: NgbModal,
    private loaderService: LoaderService
  ) {
    const currentUser = getCurrentUser();
    if (currentUser && currentUser.permissions) {
      this.userPermissions = currentUser.permissions;
    }
  }

  ngOnInit() {
    this.loadCelebrities();
  }

  hasAnyPermission(permissions: string[]): boolean {
    if (!this.userPermissions || this.userPermissions.length === 0) return false;
    return permissions.some(permission => this.userPermissions.includes(permission));
  }

  loadCelebrities() {
    this.loaderService.show();
    this.adminService.allCelebrities(this.currentPage, {
      per_page: this.itemsPerPage
    }).subscribe({
      next: (response) => {
        console.log("Réponse API:", response);
        if (!response || !response.data) {
          console.error("Erreur : données invalides reçues.");
          this.error = 'Aucune donnée reçue';
          return;
        }
        this.loading = false;
        this.allCelebrities = response.data;
        this.totalItems = response.total;
        this.totalPages = response.last_page;
        this.filterCelebrities();
      },
      error: (err) => {
        this.error = 'Erreur lors du chargement des détails';
      },
      complete: () => {
        this.loaderService.hide();
      }
    });
  }

  filterCelebrities() {
    let filtered = [...this.allCelebrities];

    if (this.searchTerm) {
      const search = this.searchTerm.toLowerCase();
      filtered = filtered.filter(celeb => 
        celeb.name.toLowerCase().includes(search) ||
        celeb.prenom.toLowerCase().includes(search) ||
        celeb.email.toLowerCase().includes(search)
      );
    }

    if (this.statusFilter) {
      filtered = filtered.filter(celeb => celeb.status === this.statusFilter);
    }

    this.filteredCelebrities = filtered;
  }

  updateStatus(id: number, status: 'active' | 'inactive') {
    this.adminService.updateCelebrityStatus(id, status).subscribe(() => {
      this.loadCelebrities();
    });
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadCelebrities();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadCelebrities();
    }
  }

  async deleteCelebrity(id: number) {
    const confirmed = await this.confirmationService.confirm(
      'Êtes-vous sûr de vouloir supprimer cette célébrité ?'
    );

    if (confirmed) {
      this.adminService.deleteCelebrity(id).subscribe(() => {
        this.loadCelebrities();
      });
    }
  }

  addCelebrity(){
    this.modal.open(AddCelebrityComponent, { size: 'lg', windowClass: 'Choose-photo-modal' })
  }

  editCelebrity(celebrity: Celebrity) {
    const modalRef = this.modal.open(EditCelebrityComponent, { 
      size: 'lg', 
      windowClass: 'Choose-photo-modal' 
    });
    
    modalRef.componentInstance.celebrity = celebrity;

    // Écouter la fermeture du modal
    modalRef.closed.subscribe(result => {
      // Recharger la liste des célébrités après la fermeture du modal
      this.loadCelebrities();
    });
  }

} 